import { useParams } from 'react-router-dom';
import { makeStyles, Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { navigateToRoute, selectBreadcrumbs } from '../../../redux_store';


const useStyles = makeStyles(() => ({
  wrapper: {
    height: '100%',
  },
}));

const PublicRoute = ({ route, ...rest }) => {
  const classes = useStyles();
  const {
    additional: { component: Component },
  } = rest;
  const params = useParams();
  const dispatch = useDispatch();
  const breadcrumbs = useSelector(selectBreadcrumbs) || [];

  if (!breadcrumbs.length) {
    dispatch(navigateToRoute({ route: { path: rest.path, params }}));
  }

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.wrapper}
    >
      <Component {...route} />
    </Grid>
  );
};

PublicRoute.propTypes = {};

export default PublicRoute;
